import { useCallback, useState } from "react";

interface UseDownloadOptions {
  fileName: string;
  getFileContent: () => Promise<string>;
  onError: (error: unknown) => void;
}

function useDownload(options: UseDownloadOptions) {
  const { fileName, getFileContent, onError } = options;

  const [downloading, setDownloading] = useState(false);

  const handleDownload = useCallback(async () => {
    try {
      setDownloading(true);
      const content = await getFileContent();
      download(fileName, content);
    } catch (error) {
      onError(error);
    } finally {
      setDownloading(false);
    }
  }, [fileName, getFileContent, onError]);

  return { handleDownload, downloading };
}

function download(fileName: string, content: string) {
  const element = document.createElement("a");
  element.setAttribute(
    "href",
    "data:text/plain;charset=utf-8," + encodeURIComponent(content),
  );
  element.setAttribute("download", fileName);
  element.style.display = "none";
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
}

export default useDownload;
